import React from 'react';
import {
  TextField,
  Box,
  Typography,
  Paper,
  LinearProgress,
} from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';

const ScriptEditor = ({
  value,
  onChange,
  minLength = 20,
  maxLength = 1000,
  error,
  helperText,
}) => {
  const characterCount = value.length;
  const progress = (characterCount / maxLength) * 100;
  const isMinReached = characterCount >= minLength;
  const isMaxReached = characterCount >= maxLength;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        border: '1px solid',
        borderColor: error ? 'error.main' : 'divider',
        borderRadius: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <EditNoteIcon color="primary" fontSize="small" />
        <Typography variant="subtitle2" fontWeight={600}>
          Your Script
        </Typography>
      </Box>

      <TextField
        fullWidth
        multiline
        rows={6}
        value={value}
        onChange={(e) => {
          if (e.target.value.length <= maxLength) {
            onChange(e.target.value);
          }
        }}
        placeholder="Write your script here or select a script above..."
        error={error}
        helperText={helperText}
        sx={{
          '& .MuiOutlinedInput-root': {
            fontFamily: 'monospace',
            fontSize: '0.95rem',
            lineHeight: 1.6,
          },
        }}
      />

      <Box sx={{ mt: 2 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 0.5,
          }}
        >
          <Typography
            variant="caption"
            color={!isMinReached ? 'error' : 'text.secondary'}
          >
            {!isMinReached
              ? `${minLength - characterCount} characters needed`
              : `Minimum reached ✓`}
          </Typography>
          <Typography
            variant="caption"
            color={isMaxReached ? 'error' : 'text.secondary'}
            fontWeight={isMaxReached ? 600 : 400}
          >
            {characterCount} / {maxLength}
          </Typography>
        </Box>
        <LinearProgress
          variant="determinate"
          value={Math.min(progress, 100)}
          color={isMaxReached ? 'error' : 'primary'}
          sx={{ height: 4, borderRadius: 2 }}
        />
      </Box>
    </Paper>
  );
};

export default ScriptEditor;
